import { RANGE_DASH, selectedEndNode } from './paragraph-reference'

function selectedStartNode(range: Range): Node {
  const { startContainer, startOffset } = range
  if (range.collapsed || (startContainer.nodeType === Node.TEXT_NODE && startOffset < (startContainer as Text).length)) {
    return startContainer
  }
  const boundary = startContainer.nodeType === Node.TEXT_NODE ? startContainer : startContainer.childNodes[startOffset]
  if (!boundary) {
    return startContainer.lastChild ?? startContainer
  }
  if (boundary !== startContainer && boundary.nodeType === Node.TEXT_NODE && isText(boundary)) {
    return boundary
  }
  // An anchor at the end of a text node selects nothing of it; the first selected text decides the page.
  const walker = document.createTreeWalker(range.commonAncestorContainer, NodeFilter.SHOW_TEXT, {
    acceptNode: node => (isText(node) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP),
  })
  walker.currentNode = boundary
  return walker.nextNode() ?? boundary
}

function isText(node: Node): boolean {
  return Boolean(node.textContent?.trim())
}

function pageAt(node: Node): string | undefined {
  const element = node.nodeType === Node.TEXT_NODE ? node.parentElement : (node as Element)
  const wrapper = element?.closest('[data-citation-source="article"]')
  if (!wrapper) {
    return undefined
  }
  let page = wrapper.getAttribute('data-citation-start-page') ?? undefined
  for (const marker of Array.from(wrapper.querySelectorAll('.jats-page-break[data-page]'))) {
    // A boundary sitting on the marker itself begins on that marker's page.
    if (marker !== node && !(marker.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING)) {
      break
    }
    page = marker.getAttribute('data-page') ?? page
  }
  return page
}

export function resolvePageRange(range: Range): string | undefined {
  const start = pageAt(selectedStartNode(range))
  const end = start ? pageAt(selectedEndNode(range, isText)) : undefined
  if (!start || !end) {
    return undefined
  }
  return start === end ? start : `${start}${RANGE_DASH}${end}`
}
